import Avatar from './Avatar';

export default Avatar;



// WEBPACK FOOTER //
// ./src/Avatar/index.js